import React from 'react'
import VideosList from './VideosList'
import PlanEntryListHeader from '../planEntry/PlanEntryListHeader'
import PropTypes from 'prop-types'

const VideosListContent = props => {
  let videoListProps = {
    entries: props.entryListOrigin.entries,
    playlistPos: props.playlistPos,
    playlistUUID: props.entryListOrigin.uuid,
    showPlanTitle: props.showPlanTitle,
    type: props.type
  }
  return (
    <div className='video-list-content'>
      <PlanEntryListHeader {...props} />
      <div className='entries-container'>
        <VideosList {...videoListProps} />
      </div>
    </div>
  )
}

VideosListContent.propTypes = {
  entryListOrigin: PropTypes.object,
  playlistPos: PropTypes.number,
  showPlanTitle: PropTypes.bool,
  type: PropTypes.string
}

export default VideosListContent
